'use client';

import { c as _c } from "react/compiler-runtime";
import { checkAccess, useAuth } from '@repo/auth';
import { permissions, roleNames } from '@repo/permissions';
import { useRouter } from 'next/navigation';
import { useQuickCreateLoad } from '@/app/@protected/_components/load-quick-create/quick-create-load-host.tsx';
import { getLoadCreationCapabilities, loadCreationAccessRequirements } from '@/app/@protected/loads/_utils/load-creation-access.ts';
import { useGlobalShortcut } from './_hooks/use-global-shortcut.ts';
import { useGodMode } from './god-mode-provider.tsx';
export const GlobalShortcuts = () => {
  const $ = _c(27);
  const router = useRouter();
  const {
    open: openQuickCreateLoad
  } = useQuickCreateLoad();
  const {
    user
  } = useAuth();
  const {
    canUseGodMode,
    toggleGodMode
  } = useGodMode();
  let t0;
  if ($[0] !== user) {
    t0 = checkAccess(user, {
      match: "any",
      permissions: [permissions.loads.list],
      roles: [roleNames.superAdmin]
    });
    $[0] = user;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const canListLoads = t0.allowed;
  let t1;
  if ($[2] !== user) {
    t1 = getLoadCreationCapabilities({
      canCreateDraft: checkAccess(user, loadCreationAccessRequirements.createDraft).allowed,
      canCreateNormalLoad: checkAccess(user, loadCreationAccessRequirements.createNormalLoad).allowed,
      canPublishDraft: checkAccess(user, loadCreationAccessRequirements.publishDraft).allowed
    });
    $[2] = user;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const loadCreationAccess = t1;
  let t2;
  if ($[4] !== user) {
    t2 = checkAccess(user, {
      match: "any",
      permissions: [permissions.companies.view],
      roles: [roleNames.superAdmin]
    });
    $[4] = user;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const canViewCompanies = t2.allowed;
  let t3;
  if ($[6] !== user) {
    t3 = checkAccess(user, {
      match: "any",
      permissions: [permissions.users.list],
      roles: [roleNames.superAdmin]
    });
    $[6] = user;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const canListUsers = t3.allowed;
  let t4;
  if ($[8] !== user) {
    t4 = checkAccess(user, {
      match: "any",
      permissions: [permissions.permissionGroups.list],
      roles: [roleNames.superAdmin]
    });
    $[8] = user;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const canListPermissions = t4.allowed;
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = ["G", "L"];
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== router) {
    t6 = () => router.push("/loads");
    $[11] = router;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  useGlobalShortcut(t5, t6, canListLoads);
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = ["G", "C"];
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== router) {
    t8 = () => router.push("/management/customers");
    $[14] = router;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  useGlobalShortcut(t7, t8, canViewCompanies);
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = ["G", "U"];
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== router) {
    t10 = () => router.push("/management/users");
    $[17] = router;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  useGlobalShortcut(t9, t10, canListUsers);
  let t11;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = ["G", "P"];
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== router) {
    t12 = () => router.push("/management/users/roles");
    $[20] = router;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  useGlobalShortcut(t11, t12, canListPermissions);
  let t13;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = ["N", "L"];
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== router) {
    t14 = () => router.push("/loads/new");
    $[23] = router;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  useGlobalShortcut(t13, t14, loadCreationAccess.canOpenNewPage);
  let t15;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = ["C"];
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  useGlobalShortcut(t15, openQuickCreateLoad, loadCreationAccess.canQuickCreate);
  let t16;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = ["G", "G"];
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  useGlobalShortcut(t16, toggleGodMode, canUseGodMode);
  return null;
};